function isValid(email: string): boolean {
  return !!email.toLowerCase().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
}

function decodeEmail(emailEncoded: string): string {
  return decodeURI(emailEncoded);
}

export const emailUtils = { isValid, decodeEmail };
